import { createFileRoute, Link } from "@tanstack/react-router";
import { Handshake } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { privatePageMetadata } from "@/lib/seo";
import { useT } from "@/i18n";

export const Route = createFileRoute("/app/collabs")({
  head: () =>
    privatePageMetadata(
      "/app/collabs",
      "Collabs | BeHot.Now",
      "Creator collaborations, coming soon.",
    ),
  component: Collabs,
});

function Collabs() {
  const { t } = useT();
  return (
    <div className="max-w-3xl">
      <section className="card-surface space-y-4 p-8 text-center">
        <Handshake className="mx-auto size-8 text-primary" />
        <Badge variant="outline" className="uppercase tracking-widest">
          {t("dashboard.collabs.comingSoon")}
        </Badge>
        <h2 className="font-display text-2xl font-bold">{t("dashboard.collabs.heading")}</h2>
        <p className="mx-auto max-w-xl text-sm text-muted-foreground">
          {t("dashboard.collabs.desc")}
        </p>
        <div className="flex flex-wrap justify-center gap-2 pt-2">
          <Button asChild variant="hot">
            <Link to="/app/profile">{t("dashboard.collabs.completeProfile")}</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/marketplace">{t("dashboard.collabs.aboutMarketplace")}</Link>
          </Button>
        </div>
      </section>
    </div>
  );
}
